import InfoIcon from 'assets/icons/infoIcon';
import { Fragment, HTMLAttributes, MouseEvent } from 'react';
import { getMergedClassNames } from 'utils/HTMLUtils';
import TooltipCaller from '../TooltipManager/TooltipCaller';
import styles from './HelpButton.scss';
const rootClassName = styles.rootClassName;

interface Props {
  text?: string;
  tooltipCallerClassName?: string;
  className?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  placement?: string;
  style?: HTMLAttributes<HTMLDivElement>['style'];
}
export default function HelpButton(props: Props) {
  return props.text ? (
    <TooltipCaller text={props.text} className={props.tooltipCallerClassName}>
      <div
        style={props.style}
        className={getMergedClassNames([rootClassName, props.className])}
        onClick={props.onClick}
      >
        <InfoIcon className={rootClassName + '-icon'} />
      </div>
    </TooltipCaller>
  ) : (
    <Fragment />
  );
}
